import TextContainer from "./TextContainer";

export default TextContainer;
